export const SET_ACTIVE_LINE = 'SET_ACTIVE_LINE';

export function setActiveLine(payload) {
  return {
    type: SET_ACTIVE_LINE,
    payload,
  };
}
